export default __webpack_public_path__ + "static/media/view_record.83e1e523.png";